
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface ProfileActionsProps {
  isSaving: boolean;
  onSave: () => Promise<void>;
}

export const ProfileActions = ({ isSaving, onSave }: ProfileActionsProps) => {
  return (
    <Button 
      onClick={onSave} 
      disabled={isSaving}
      className="w-full mt-6 bg-[#00B6F0] hover:bg-[#0095c7] text-black font-medium"
    >
      {isSaving ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Salvando...
        </>
      ) : "Salvar Alterações"}
    </Button>
  );
};
